export function carTypeFilter(value) {
    var types = [
        { value: 'VOITURE_MANUELLE', label: 'Car manual gearbox' },
        { value: 'VOITURE_AUTO', label: 'Car automatic gearbox' },
        { value: 'MOTO', label: 'Motor scooter' },
        { value: 'QUAD', label: 'Quad' }
    ];
    for (var i = 0; i < types.length; i++) {
        if (types[i].value === value) {
            return types[i].label;
        }
    }
};